import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from './medusa/config';

// Singleton: loadStripe se llama una sola vez y se reutiliza la promesa.
// Si no hay llave configurada, devolvemos null y el checkout muestra un aviso
// en vez de romper.
let stripePromise;

export function getStripe() {
  if (!STRIPE_PUBLISHABLE_KEY) {
    console.warn('Stripe: falta REACT_APP_STRIPE_PUBLISHABLE_KEY');
    return null;
  }
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
}

export const isStripeConfigured = Boolean(STRIPE_PUBLISHABLE_KEY);
